import {
  getCookie,
  isConsentCategoryEnabled,
  OneTrustCategories,
} from '@susu/cookie'

type AffiliateData = {
  awc: string
  affiliateMarker: string
}

/**
 * Get affiliate data from cookies.
 *
 * `awc` normally arrives via Awin's own MasterTag, which writes the `awc`
 * cookie itself. That tag can take a moment to fire (or never fire in a
 * non-Awin-configured environment), so `capturedAwc` — the same URL param
 * captured independently by `getMarketingClickIds()` — is used whenever the
 * real cookie hasn't landed yet. The real cookie always wins when present.
 */
export const getAffiliateDataFromCookie = (
  capturedAwc?: string,
): AffiliateData => {
  if (!isConsentCategoryEnabled(OneTrustCategories.ADVERTISING)) {
    return { awc: '', affiliateMarker: '' }
  }

  const awc = getCookie('awc') ?? capturedAwc ?? ''
  const affiliateMarker = getCookie('affiliateMarker') ?? ''

  return { awc, affiliateMarker }
}
